import React, { useEffect } from 'react'
import Trusted from '../HomeMain/Trusted/Main'
import Features from '../HomeMain/Features/Main'
import AboutApp from '../HomeMain/AboutApp/Main'
import Design from '../HomeMain/Design/Main'
import Testimonial from '../HomeMain/Testimonial/Main'
import Pricing from '../HomeMain/Pricing/Main'
import Faq from '../HomeMain/Faq/Main'
import Interface from '../HomeMain/Interface/Main'
import Download from '../HomeMain/Download/Main'
import Story from '../HomeMain/Story/Main'
import Banner from '../Menhomevideo/Banner';
import How from '../Menhomevideo/How';

const Main = ({ setnavbar, setfooter, setbrdcum }) => {

    useEffect(() => {
        setfooter({ f1: true })
        setnavbar({ n6: true })
        setbrdcum({ b3: true })
        localStorage.setItem("navbar", "homevideo")

    }, [])

    return (
        <>
            <Banner />
            <Trusted />
            <Features video={true} />
            <AboutApp video={true} />
            <Design />
            <How />
            <Testimonial />
            <Pricing video={true} />
            <Faq />
            <Interface />
            <Download />
            <Story />
        </>
    )
}

export default Main